import React from 'react';

const ReportTabs = ({ reportType, fieldsBySection }) => {
  if (!reportType || Object.keys(fieldsBySection).length === 0) {
    return null;
  }

  return (
    <div className="report-tabs">
      <ul className="nav nav-tabs" role="tablist">
        {Object.keys(fieldsBySection).map((section, idx) => (
          <li key={section} className="nav-item" role="presentation">
            <button
              className={`nav-link ${idx === 0 ? 'active' : ''}`}
              id={`${section}-tab`}
              data-bs-toggle="tab"
              data-bs-target={`#${section}`}
              type="button"
              role="tab"
              aria-controls={section}
              aria-selected={idx === 0}
            >
              {section}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content mt-3">
        {Object.entries(fieldsBySection).map(([section, fields], idx) => (
          <div
            key={section}
            className={`tab-pane fade ${idx === 0 ? 'show active' : ''}`}
            id={section}
            role="tabpanel"
            aria-labelledby={`${section}-tab`}
          >
            <div className="row g-3">
              {fields.map((field) => (
                <div key={field._id} className="col-md-3">
                  <label htmlFor={field._id} className="form-label fw-bold">
                    {field.label}:
                  </label>
                  <input
                    type={field.type || 'text'}
                    className="form-control"
                    id={field._id}
                    name={field._id}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportTabs;
